let AbstractGeometryOperationResult = require('./abstractOperationResult');

/**
 * Класс DifferenceResult определяет структуру результата при опрерации построения разницы геометрий
 * @extends AbstractGeometryOperationResult
 */
class DifferenceResult extends AbstractGeometryOperationResult {
  /**
   * Создает экземпляр класса DifferenceResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "DifferenceResult";
  }
}

module.exports = DifferenceResult;